import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6610fa38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__title" }, " Вход или регистрация ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__subtitle" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "system-alert danger" }
const _hoisted_4 = { class: "system-alert__wrapper" }
const _hoisted_5 = { class: "auth-form__confirm" }
const _hoisted_6 = { class: "auth-form__confirm-info" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString($props.service.configuration.esiaErrorMessage), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          innerHTML: $props.service.configuration.esiaErrorMessageDetails
        }, null, 8 /* PROPS */, _hoisted_7)
      ])
    ]),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onBack())),
      href: "javascript:void(0)",
      class: "auth-form__btn button button-primary"
    }, "Войти по телефону")
  ], 64 /* STABLE_FRAGMENT */))
}